import PropTypes from 'prop-types';
import React from 'react';
import { FieldArray } from 'redux-form';
import { t } from '../../../../../modules/infra/i18n';
import Select from '../../../../common/select';
import Icon, { GLYPHS } from '../../../../common/icon';

const renderShops = ({ fields, meta: { touched, error }, shops, showLabels, canModify, hideError }) => (
  <div>
    <div className="u-pt- zeta">
      {fields.map((shopId, index) =>
        <div key={index}>
          <div className="c-label-new" display-if={showLabels}>{t('admin:users.shop_array.shop_label')}</div>
          <div className="o-flexbox u-mb-">
            <div className="o-flexbox__item o-flexbox__item--flex-1">
              <Select
                name={shopId}
                className="c-select"
                options={shops}
                textField="name"
                valueField="id"
                empty={t('admin:users.shop_array.choose_shop_placeholder')}
                hideError={hideError}
              />
            </div>
            <div className="o-flexbox__item c-btn c-btn--delete u-ml-" display-if={canModify}>
              <Icon
                glyph={GLYPHS.closeBtn}
                size="micro"
                className="o-icon--pointer"
                onClick={() => fields.remove(index)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
    <div>
      <button
        className="c-btn c-btn--blank c-btn--link u-p0"
        type="button"
        onClick={() => fields.push(fields.get(fields.length - 1) || {})}
        data-automation-id="add-shop"
        display-if={canModify}
      >
        <Icon glyph={GLYPHS.plus} size="medium" />
        <span className="c-btn__text">{t('admin:users.add.add_shop_link')}</span>
      </button>
      {touched && error && !hideError && <div className="c-input-error-message">{error}</div>}
    </div>
  </div>
);

const ShopArray = ({ shops, name, showLabels, canModify, hideError }) => (
  <FieldArray
    name={name}
    component={renderShops}
    shops={shops}
    showLabels={showLabels}
    canModify={canModify}
    hideError={hideError}
  />
);

ShopArray.propTypes = {
  shops: PropTypes.array.isRequired,
  name: PropTypes.string,
  showLabels: PropTypes.bool,
  canModify: PropTypes.bool,
  hideError: PropTypes.bool,
};

ShopArray.defaultProps = {
  name: 'shopIds',
  showLabels: false,
  canModify: true,
  hideError: false,
};

export default ShopArray;
